import { render, staticRenderFns } from "./AddBlacklistEntryModal.vue?vue&type=template&id=55c3a758&"
import script from "./AddBlacklistEntryModal.vue?vue&type=script&lang=js&"
export * from "./AddBlacklistEntryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports